import { render, staticRenderFns } from "./select-purchase-modal.vue?vue&type=template&id=624ec5ee&scoped=true&"
import script from "./select-purchase-modal.vue?vue&type=script&lang=ts&"
export * from "./select-purchase-modal.vue?vue&type=script&lang=ts&"
import style0 from "./select-purchase-modal.vue?vue&type=style&index=0&id=624ec5ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ec5ee",
  null
  
)

export default component.exports